module.exports = "/_next/static/images/075faa5dcc6f844c6ab88d62b6eaa219-complexity@md-1x.jpg";